import {
    GET_DEPOT_LIST_PROGRESS, GET_DEPOT_LIST_SUCCESS, GET_DEPOT_LIST_FAILURE,
    ADD_DEPOT_PROGRESS, ADD_DEPOT_SUCCESS, ADD_DEPOT_FAILURE,
    EDIT_DELETE_DEPOT_PROGRESS, EDIT_DELETE_DEPOT_SUCCESS, EDIT_DELETE_DEPOT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    depot: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const depot_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_DEPOT_LIST_SUCCESS:
            return { ...state, depot: action.depot, loading: false };
        case GET_DEPOT_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_DEPOT_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_DEPOT_PROGRESS:
            return { ...state, loading: true };
        case ADD_DEPOT_SUCCESS:
            return { ...state, depot: [...state.depot, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_DEPOT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_DEPOT_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_DEPOT_SUCCESS:
            return {
                ...state,
                depot: state.depot.map((depot) =>
                    depot.id === action.payload.id ? action.payload : depot
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_DEPOT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default depot_reducer;